module.exports = __webpack_public_path__ + "static/img/title.92cc3e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/feature/title.png
// module id = zUvI
// module chunks = 7